"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var required_1 = require("./required");
var email_1 = require("./email");
var length_1 = require("./length");
exports.validationProps = (_a = {},
    _a["required" /* Required */] = required_1.required,
    _a["requiredBoolean" /* RequiredBoolean */] = required_1.requiredBoolean,
    _a["minLengthOrEmpty" /* MinLengthOrEmpty */] = length_1.minLengthOrEmpty,
    _a["minLength" /* MinLength */] = length_1.minLength,
    _a["maxLength" /* MaxLength */] = length_1.maxLength,
    _a["email" /* Email */] = email_1.email,
    _a);
